import { Performer } from '../../core/performer'
import { HttpMethod } from '../../core/types'

export class VerifyChatter extends Performer<
  {
    urlParams: {
      id: number
    }
  },
  void
> {
  protected method = HttpMethod.POST
  protected url = '/chatters/{id}/verify'
}

export default new VerifyChatter().perform
